import React, { useEffect, useRef, useState } from "react";
import firebase from "firebase";
import {
  Button,
  CircularProgress,
  Grid,
  makeStyles,
  Modal,
  Paper,
  Select,
  StepButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { TextField, Switch } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import emailjs from "emailjs-com";
import _, { isArray, isEqual, isNull, isUndefined } from "underscore";
import MyTextArea from "./MyTextArea";

function AdminPrijavePredavaca() {
  const [predavaci, setPredavaci] = useState(null);
  const [predavaciToShow, setPredavaciToShow] = useState(null);
  const [numOfPredavaci, setNumOfPredavaci] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [spinner,setSpinner] = useState(false)
  
  const[buttonDesign,setButtonDesign] = useState(true)

  useEffect(() => {
    if (predavaci === null) {
      firebase
        .database()
        .ref("Predavaci")
        .once("value")
        .then((res) => {
          setPredavaci(res.val());
          if(_.isNull(res.val())|| _.isUndefined(res.val())){
            setPredavaciToShow([]);
            setNumOfPredavaci(0);
          }
          else if (_.isNull(res.val().prijave) || _.isUndefined(res.val().prijave)) {
            setPredavaciToShow([]);
            setNumOfPredavaci(0);
          } else {
            setPredavaciToShow(res.val().prijave);
            setNumOfPredavaci(Object.keys(res.val().prijave).length);
          }
        })
        .catch((err) => alert(err));
    }
  }, [predavaci, predavaciToShow]);

  //firebase
  const db = firebase.database();

  //stlyes
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

  const handleChangePage = (event, newPage) => {
    setPageNumber(newPage);
  };

  function handlePredavaci() {
    setButtonDesign(true)
    if(_.isNull(predavaci)|| _.isUndefined(predavaci)){
      setPredavaciToShow([]);
      setNumOfPredavaci(0);
    }
    else if (isNull(predavaci.prijave) || isUndefined(predavaci.prijave)) {
      setPredavaciToShow([]);
      setNumOfPredavaci(0);
    } else {
      setPredavaciToShow(predavaci.prijave);
      setNumOfPredavaci(Object.keys(predavaci.prijave).length);
    }
  }
  function handleOdobrenePrijave() {
    setButtonDesign(false)
    if(_.isNull(predavaci)|| _.isUndefined(predavaci)){
      setPredavaciToShow([]);
      setNumOfPredavaci(0);
    }
    else if (_.isNull(predavaci.odobreni) || _.isUndefined(predavaci.odobreni)) {
      setPredavaciToShow([]);
      setNumOfPredavaci(0);
    } else {
      setPredavaciToShow(predavaci.odobreni);
      setNumOfPredavaci(Object.keys(predavaci.odobreni).length);
    }
  }

  const handleChangeRowsPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPageNumber(0);
  };

  function Red(props) {
    const { predavac, count, ID } = props;

    const [modal, setmodal] = useState(false);
    

    function deletePredavac(ID) {
      if (_.isEqual(predavaciToShow, predavaci.prijave)) {
        firebase
          .database()
          .ref("Predavaci/prijave/" + ID)
          .remove()
          .then((e) => {

            window.location.reload(false);
          });
      } else {
        firebase
          .database()
          .ref("Predavaci/odobreni/" + ID)
          .remove()
          .then((e) => {
            window.location.reload(false);
          });
      }
    }

    function openModal() {
      setmodal(true);
    }

    function closeModal() {
      setmodal(false);
    }
    return (
      <React.Fragment>
        <TableRow>
          <TableCell>{count}</TableCell>
          <TableCell align="right">{predavac.name}</TableCell>
          <TableCell align="right">{predavac.surname}</TableCell>
          <TableCell align="right">{predavac.email}</TableCell>
          <TableCell align="right">{predavac.time}</TableCell>
          <TableCell align="right">{predavac.naziv}</TableCell>
          <TableCell align="right">{predavac.vrsta}</TableCell>
          <TableCell align="right">{predavac.vrijeme}</TableCell>
          {!_.isUndefined(predavac.payDate)?<TableCell align="right">{new Date(predavac.payDate).toLocaleDateString()}</TableCell>:null}
          <TableCell align="right">
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#45B283" }}
              onClick={() => openModal()}
            >
              {buttonDesign?"Odbri":"Uredi"}
            </Button>
          </TableCell>
          <TableCell align="right">
            <Button
              variant="contained"
              color="primary"
              style={{ backgroundColor: "#9A4E43" }}
              onClick={() => deletePredavac(ID)}
            >
              X
            </Button>
          </TableCell>
        </TableRow>
        {/* MODLA START */}
        <React.Fragment>
          <Modal
            open={modal}
            onClose={closeModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ margin: "0 auto", width: "50%", overflow: "scroll" }}
          >
           
            <EditPredavac ID={ID} close={closeModal}></EditPredavac>
            
          </Modal>
        </React.Fragment>
        {/* MODAL END */}
      </React.Fragment>
    );
  }

  function EditPredavac(props) {
    const { ID, close } = props;

    const [predavac, setPredavac] = useState(predavaciToShow[ID]);
    const [uplatio, setUplatio] = useState(false);
    const [upload, setUpload] = useState(false);
   

    const ref = useRef(null);

    function handleSubmit(values) {
    
      let typeOfPredavaci = _.isEqual(predavaciToShow, predavaci.prijave)
        ? "prijave"
        : "odobreni";

      
      firebase
        .database()
        .ref("Predavaci/" + typeOfPredavaci + "/" + ID)
        .set(values);
      window.location.reload(false);
    }


    function handleOdobri() {
        setSpinner(true)

        firebase.database()
        .ref("Predavaci/odobreni" + "/" + ID)
        .set({...predavac,payDate:ref.current.values.payDate})
        .then((e) => {
          firebase
            .database()
            .ref("Predavaci/prijave" + "/" + ID)
            .remove()
            .then(()=>{
              emailjs
              .send(
                "serviceProba",
                "OdobreniPredavac",
                {
                  email: predavac.email,
                  naziv:predavac.naziv,
                },
                "user_hU4wKMTGiLWs2jfLyPHR4"
              )
              .then((res) => {
                // TODO SPINNER AND DISABLE PAGE
                setSpinner(false)
                window.location.reload(false)
                 
              })
              .catch((err) => {
                alert("Pogreška pri slanju Pokušaj te kasnije ponovno");
                console.log(err);
              });
            })
        });
    }

    useEffect(() => {}, [predavac]);

    return (
      <React.Fragment>
        {predavac === null || spinner ? (
          <CircularProgress />
        ) : (
          <Formik
            innerRef={ref}
            initialValues={{...predavac,payDate:""}}
            onSubmit={(values) => {
              handleSubmit(values);
            }}
          >
            <Form>
              <Grid
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  border: "5px solid lightblue",
                }}
                container
                direction="column"
              >
                <Grid item>
                  <Field
                    component={TextField}
                    label="Ime"
                    required
                    name="name"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Prezime"
                    required
                    name="surname"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Email"
                    required
                    name="email"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item>
                  <FormControl style={{ width: "100%" }}>
                    {/* TODO CHANGE LABELS ON CHANGE */}
                    <InputLabel htmlFor="age-simple" style={{ width: "50%" }}>
                      Vrsta izlaganja{" "}
                    </InputLabel>
                    <Field
                      style={{ width: "100%" }}
                      component={Select}
                      name="vrsta"
                      inputProps={{
                        id: "age-simple",
                        defaultValue: predavac.vrsta,
                      }}
                    >
                      <MenuItem value={"Predavanje"}>Predavanje</MenuItem>
                      <MenuItem value={"Radionica"}>Radionica</MenuItem>
                    </Field>
                  </FormControl>
                </Grid>
                <Grid item>
                  <Field
                    style={{ width: "100%" }}
                    component={TextField}
                    label={"Naziv " + predavac.vrsta}
                    required
                    name="naziv"
                    type="text"
                  />
                </Grid>
                <Grid item>
                  <MyTextArea
                    label={"Opis " + predavac.vrsta}
                    name="opis"
                    type="text"
                    rows="8"
                    placeholder="Unesite opis događaja"
                    style={{ width: "100%", marginTop: "10px" }}
                    required
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Tkome je predavanje namjenjeno"
                    required
                    name="namjeneno"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Potreban pribor"
                    required
                    name="pribor"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Ciljevi i zadaci radionice"
                    required
                    name="cilj"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>
                <Grid item>
                  <Field
                    component={TextField}
                    label="Datum prijave"
                    required
                    name="time"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item>
                  {/* TODO ON CLICK MAKE FEILD */}
                  <Field
                    component={TextField}
                    label="Link na rad"
                    required
                    name="urlRad"
                    type="text"
                    style={{ width: "100%" }}
                  />
                  <Typography variant="caption">{predavac.urlRad}</Typography>
                  <button type="button">Uredi</button>
                </Grid>

                <Grid item>
                  <Field
                    component={TextField}
                    label={"Duljina trajanja " + predavac.vrsta + " (min)"}
                    required
                    name="vrijeme"
                    type="text"
                    style={{ width: "100%" }}
                  />
                </Grid>

                <Grid item>
                  {/* PAYED */}
                  <label for="payed">Uplatio</label>
                  <Field
                    component={Switch}
                    label="Uplatio"
                    required
                    name="payed"
                    onChange={(e, check) => setUplatio(check)}
                    checked={uplatio}
                  />
                  {uplatio ? (
                    <>
                      <Grid item>
                      <label for="payed">Datum Uplate</label>
                        <Field
                          component={TextField}
                          type="date"
                          name="payDate"
                         
                          required
                          style={{width:"50%"}}
                        />
                      </Grid>
                    </>
                  ) : null}
                </Grid>

                <br></br>
                {_.isEqual(predavaciToShow, predavaci.prijave) ? (
                  <Button
                    variant="contained"
                    onClick={handleOdobri}
                    color="secondary"
                    disabled={!uplatio}
                    type="button"
                    style={{  width: "100%",
                   backgroundColor: "#1F94C2" }}
                  >
                    Odobri
                  </Button>
                ) : null}
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{
                    width: "100%",
                    marginTop: "20px",
                    backgroundColor: "#9A4E43",
                  }}
                  onClick={close}
                >
                  Odustani
                </Button>
              </Grid>
            </Form>
          </Formik>
        )}
      </React.Fragment>
    );
  }

  const classes = useStyles();
  return (
    <div>
      <Button onClick={handlePredavaci} disable={predavaci === null}>
        <Typography variant="h3" style={{borderBottom:buttonDesign?"3px solid #45B283":"",

}}>Predavaci</Typography>
      </Button>
      <Button onClick={handleOdobrenePrijave} disable={predavaci === null}>
        <Typography variant="h3" style={{borderBottom:!buttonDesign?"3px solid #45B283":"",

}}>Odobreni predavaci</Typography>
      </Button>

      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell align="right">Ime</TableCell>
              <TableCell align="right">Prezime</TableCell>
              <TableCell align="right">Email</TableCell>
              <TableCell align="right">Datum prijave</TableCell>
              <TableCell align="right">Naslov</TableCell>
              <TableCell align="right">Vrsta Predavanja</TableCell>
              <TableCell align="right">Trajanje (min)</TableCell>
              {buttonDesign?null:<TableCell align="right">Datum plaćanja</TableCell>}
              <TableCell align="right"></TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>

          {predavaciToShow === null ? (
            <CircularProgress />
          ) : (
            <TableBody>
              {Object.keys(predavaciToShow)
                .slice(
                  pageNumber * rowsPerPage,
                  pageNumber * rowsPerPage + rowsPerPage
                )
                .map((key, indx) => {
                  return (
                    <Red
                      count={indx + 1}
                      predavac={predavaciToShow[key]}
                      ID={key}
                      key={key}
                    />
                  );
                })}
            </TableBody>
          )}
        </Table>

        <TablePagination
          count={numOfPredavaci}
          page={pageNumber}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          onChangeRowsPerPage={handleChangeRowsPage}
          rowsPerPageOptions={[10, 25, 100]}
        />
      </TableContainer>
    </div>
  );
}

export default AdminPrijavePredavaca;
